module.exports = __webpack_public_path__ + "static/img/strategy-bg-left.e41fc25c.png";